import { css } from 'styled-components';

export const referenceWrapperExpanded = () => css`
  flex: 1 1 100%;
`;

export const referenceWrapperCollapsed = () => css`
  flex: 0 0 auto;
`;
